// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../shared/Dialog.module.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --tip-modal-size: min(75vw, clamp(320px, 90vw, 420px));
}

.sfly1SCCmOL7jRkN7MBR {
  position: absolute;
  inset: 0px;
  z-index: 1000;
  backdrop-filter: blur(4px);
  background: rgba(0, 0, 0, 0.8);
}

.uS_WFCgjmZgPd1tXxuEV {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90vw;
  width: var(--tip-modal-size);
  z-index: 1001;
}

.fIf2SThXG4xdVhQv_qde {
}

.muFoljfGIvQeXVtN0awB {
}

.xjuTy5RptaR2Y1rYYCAi {
}

.L6d65g9DtxLKbjFbtWNq {
  display: flex;
  flex-direction: column;
  min-height: calc(var(--tip-modal-size) * 0.25);
  max-height: 50vh;
}

.RmPVSlSPedy8vQzztqVB {
    position: relative;
    top: 0;
    bottom: 0;
    margin: auto 0;
}

#gw-map .RmPVSlSPedy8vQzztqVB p:first-child {
    margin-top: 0;
}

#gw-map .closeTextButton.ZqD5aId4lz0TJ1QU1kTD {
    color: var(--map-accent-color-dark) !important;
    margin-top: 0;
}`, "",{"version":3,"sources":["webpack://./../core/components/buttons/TipModal.module.css"],"names":[],"mappings":"AAAA;IACI,sDAAsD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,4BAA4B;EAC5B,aAAa;AACf;;AAEA;AAEA;;AAEA;AAEA;;AAEA;AAEA;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8CAA8C;EAC9C,gBAAgB;AAElB;;AAEA;IAEI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,8CAA8C;IAC9C,aAAa;AACjB","sourcesContent":[":root {\r\n    --tip-modal-size: min(75vw, clamp(320px, 90vw, 420px));\r\n}\r\n\r\n.modalOverlay {\r\n  position: absolute;\r\n  inset: 0px;\r\n  z-index: 1000;\r\n  backdrop-filter: blur(4px);\r\n  background: rgba(0, 0, 0, 0.8);\r\n}\r\n\r\n.modalDialog {\r\n  composes: container from '../shared/Dialog.module.css';\r\n  position: relative;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  max-width: 90vw;\r\n  width: var(--tip-modal-size);\r\n  z-index: 1001;\r\n}\r\n\r\n.modalHeader {\r\n    composes: headerContainer from '../shared/Dialog.module.css';\r\n}\r\n\r\n.modalTitle {\r\n    composes: headerText from '../shared/Dialog.module.css';\r\n}\r\n\r\n.closeButton {\r\n    composes: closeButton from '../shared/Dialog.module.css';\r\n}\r\n\r\n.modalBody {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: calc(var(--tip-modal-size) * 0.25);\r\n  max-height: 50vh;\r\n  composes: contentContainer from '../shared/Dialog.module.css';\r\n}\r\n\r\n.modalBodyContent {\r\n    composes: content from '../shared/Dialog.module.css';\r\n    position: relative;\r\n    top: 0;\r\n    bottom: 0;\r\n    margin: auto 0;\r\n}\r\n\r\n:global(#gw-map) .modalBodyContent p:first-child {\r\n    margin-top: 0;\r\n}\r\n\r\n:global(#gw-map .closeTextButton).modalCloseTextButton {\r\n    color: var(--map-accent-color-dark) !important;\r\n    margin-top: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `sfly1SCCmOL7jRkN7MBR`,
	"modalDialog": `uS_WFCgjmZgPd1tXxuEV ${___CSS_LOADER_ICSS_IMPORT_0___.locals["container"]}`,
	"modalHeader": `fIf2SThXG4xdVhQv_qde ${___CSS_LOADER_ICSS_IMPORT_0___.locals["headerContainer"]}`,
	"modalTitle": `muFoljfGIvQeXVtN0awB ${___CSS_LOADER_ICSS_IMPORT_0___.locals["headerText"]}`,
	"closeButton": `xjuTy5RptaR2Y1rYYCAi ${___CSS_LOADER_ICSS_IMPORT_0___.locals["closeButton"]}`,
	"modalBody": `L6d65g9DtxLKbjFbtWNq ${___CSS_LOADER_ICSS_IMPORT_0___.locals["contentContainer"]}`,
	"modalBodyContent": `RmPVSlSPedy8vQzztqVB ${___CSS_LOADER_ICSS_IMPORT_0___.locals["content"]}`,
	"modalCloseTextButton": `ZqD5aId4lz0TJ1QU1kTD`
};
module.exports = ___CSS_LOADER_EXPORT___;
